/**
 * Evolution Wheels — Vehicle Session Manager
 * assets/ew-vehicle.js
 * 
 * Gestisce il ciclo di vita della selezione veicolo:
 * 1. Salva i parametri in sessionStorage al click Cerca
 * 2. Nella pagina prodotto mostra la selezione e salva cart attributes
 * 3. Nel carrello verifica la compatibilità SKU
 */

(function () {
  'use strict';

  const EW_KEY = 'ew_vehicle';
  const CDN    = (window.ewConfig && window.ewConfig.cdn) || '';

  // ── STORAGE ────────────────────────────────────────────
  const ewVehicle = {
    save(data) {
      try { sessionStorage.setItem(EW_KEY, JSON.stringify(data)); } catch(e) {}
    },
    load() {
      try { return JSON.parse(sessionStorage.getItem(EW_KEY) || 'null'); } catch(e) { return null; }
    },
    clear() {
      try { sessionStorage.removeItem(EW_KEY); } catch(e) {}
    }
  };

  // ── FORMATO LABEL ──────────────────────────────────────
  function formatLabel(v) {
    if (!v) return '';
    const parts = [];
    if (v.make)      parts.push(v.make);
    if (v.mode === 'hubcap') {
      if (v.model)     parts.push(v.model);
      if (v.sub_model) parts.push(v.sub_model + '"');
      if (v.engine)    parts.push(v.engine);
    } else {
      if (v.model)     parts.push(v.model);
      if (v.sub_model) parts.push(v.sub_model);
      if (v.engine && v.engine !== 'all') parts.push(v.engine + ' kW');
    }
    return parts.join(' · ');
  }

  // ── SALVA AL CLICK CERCA ───────────────────────────────
  // Chiamato da ew-cfg-v4.js e ew-search-bar.liquid prima del redirect
  window.ewSaveVehicle = function(data) {
    ewVehicle.save(data);
  };

  // ── PAGINA PRODOTTO ────────────────────────────────────
  async function initProductPage() {
    const vehicle = ewVehicle.load();
    if (!vehicle) return;

    const label = formatLabel(vehicle);

    // Mostra banner selezione
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      const banner = document.createElement('div');
      banner.innerHTML = `<span style="font-size:13px;">🚗 Selezione: <strong>${label}</strong></span><button type="button" style="margin-left:auto;background:none;border:none;font-size:18px;cursor:pointer;color:#999;line-height:1;">×</button>`;
      banner.style.cssText = 'display:flex;align-items:center;gap:8px;padding:10px 14px;background:#f5f5f5;border-radius:8px;font-size:13px;margin:12px 0;border-left:3px solid #DD1D1D;';
      banner.querySelector('button').addEventListener('click', () => { ewVehicle.clear(); banner.remove(); });
      const btnWrap = form.querySelector('[name="add"]')?.closest('.product-form__buttons, .product-form__submit') || form.querySelector('[name="add"]')?.parentElement;
      if (btnWrap) btnWrap.insertAdjacentElement('beforebegin', banner);
      else form.insertAdjacentElement('afterbegin', banner);
    }

    // Salva subito gli attributi (nel caso il carrello sia già presente)
    await saveCartAttributes(label, vehicle);

    // Intercetta fetch globale per /cart/add.js (Shopify AJAX)
    const origFetch = window.fetch;
    window.fetch = async function(...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const result = origFetch.apply(this, args);
      if (url.includes('/cart/add')) {
        result.then(() => saveCartAttributes(label, vehicle)).catch(() => {});
      }
      return result;
    };
  }

  async function saveCartAttributes(label, vehicle) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'ew_vehicle': label
          }
        })
      });
      console.log('[EW] Cart attributes salvati:', label);
    } catch(err) { console.warn('[EW] Cart attribute error:', err); }
  }


  // ── PAGINA CARRELLO ────────────────────────────────────
  async function initCartPage() {
    const container = document.getElementById('ew-cart-vehicle');
    if (!container) return;

    const vehicle = ewVehicle.load();
    const cdnUrl  = container.dataset.cdn || CDN;

    if (!vehicle || !vehicle.make) {
      // Nessuna selezione — mostra mini configuratore
      showCartConfigurator(container, cdnUrl);
      return;
    }

    const label = formatLabel(vehicle);

    // Verifica compatibilità SKU prodotti nel carrello
    let compatible = null;
    try {
      const cartRes  = await fetch('/cart.js');
      const cart     = await cartRes.json();
      const cartSkus = cart.items.map(i => String(i.sku));

      // Carica dati JSON per trovare gli SKU compatibili
      const compatibleSkus = await getCompatibleSkus(vehicle, cdnUrl);
      const matches = cartSkus.filter(s => compatibleSkus.includes(s));
      compatible = matches.length > 0;
    } catch(e) {
      console.warn('[EW] Compatibility check error:', e);
    }

    // Mostra banner con risultato
    const statusColor = compatible === true  ? '#22c55e' 
                      : compatible === false ? '#ef4444' 
                      : '#aaaaaa';
    const statusIcon  = compatible === true  ? '✓ Selezione confermata'
                      : compatible === false ? '✗ Abbinamento non verificato'
                      : '';
    const statusText  = compatible !== null ? `<span style="color:${statusColor};font-size:13px;font-weight:600;">${statusIcon}</span>` : '';

    container.innerHTML = `
      <div class="ew-cart-vehicle">
        <span class="ew-cart-vehicle__label">Hai scelto:</span>
        <strong class="ew-cart-vehicle__value">${label}</strong>
        ${statusText}
        <button type="button" class="ew-cart-vehicle__modify" id="ew-cart-modify">modifica</button>
        <button type="button" class="ew-cart-vehicle__clear" id="ew-cart-clear">×</button>
      </div>
      <div id="ew-cart-cfg" style="display:none;margin-top:12px;"></div>
    `;

    // Stili
    container.querySelector('.ew-cart-vehicle').style.cssText = 
      'display:flex;align-items:center;flex-wrap:wrap;gap:10px;padding:14px 18px;background:#f9f9f9;border-radius:8px;font-size:13px;';
    container.querySelector('.ew-cart-vehicle__label').style.cssText = 'color:#888;';
    container.querySelector('.ew-cart-vehicle__value').style.cssText = 'color:#111;font-weight:700;';
    container.querySelector('.ew-cart-vehicle__modify').style.cssText = 
      'margin-left:auto;background:none;border:none;font-size:13px;color:#DD1D1D;cursor:pointer;text-decoration:underline;padding:0;';
    container.querySelector('.ew-cart-vehicle__clear').style.cssText = 
      'background:none;border:none;font-size:18px;color:#999;cursor:pointer;padding:0;line-height:1;';

    // Modifica
    document.getElementById('ew-cart-modify')?.addEventListener('click', () => {
      const cfg = document.getElementById('ew-cart-cfg');
      cfg.style.display = cfg.style.display === 'none' ? 'block' : 'none';
      if (cfg.style.display === 'block' && !cfg.dataset.loaded) {
        cfg.dataset.loaded = '1';
        showCartConfigurator(cfg, cdnUrl, vehicle);
      }
    });

    // Azzera selezione
    document.getElementById('ew-cart-clear')?.addEventListener('click', async () => {
      ewVehicle.clear();
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'ew_vehicle': '' } })
      });
      container.innerHTML = '';
      showCartConfigurator(container, cdnUrl);
    });
  }

  // ── SKU COMPATIBILI ────────────────────────────────────
  async function getCompatibleSkus(vehicle, cdnUrl) {
    if (vehicle.mode === 'hubcap') {
      const hub = await fetch(cdnUrl + 'hubcap.json').then(r => r.json());
      const { make, model, sub_model: diam, engine: pcd } = vehicle;
      const skus = new Set();
      if (diam && pcd && hub?.[make]?.[model]?.[diam]?.[pcd]) {
        hub[make][model][diam][pcd].forEach(s => skus.add(String(s)));
      } else if (diam && hub?.[make]?.[model]?.[diam]) {
        Object.values(hub[make][model][diam]).forEach(arr => arr.forEach(s => skus.add(String(s))));
      } else if (hub?.[make]?.[model]) {
        Object.values(hub[make][model]).forEach(obj => Object.values(obj).forEach(arr => arr.forEach(s => skus.add(String(s)))));
      }
      return [...skus];
    } else {
      // Cerchi
      const slug = vehicle.make.replace(/\s+/g,'_').replace(/\//g,'_').toLowerCase();
      const data = await fetch(cdnUrl + slug + '_v4.json').then(r => r.json());
      const { model, sub_model: body, engine: power } = vehicle;
      const skus = new Set();
      if (power && power !== 'all') {
        (data?.fitment?.[model+'|||'+body+'|||'+power] || []).forEach(i => skus.add(String(data.eans[i])));
      } else {
        (data?.powers?.[model+'|||'+body] || []).forEach(p => 
          (data?.fitment?.[model+'|||'+body+'|||'+p] || []).forEach(i => skus.add(String(data.eans[i]))));
      }
      return [...skus];
    }
  }

  // ── MINI CONFIGURATORE NEL CARRELLO ───────────────────
  function showCartConfigurator(container, cdnUrl, prefill) {
    const mode = prefill?.mode || 'wheels';
    container.innerHTML = `
      <div class="ew-cart-cfg-wrap">
        <p class="ew-cart-cfg-title">Seleziona il tuo veicolo per verificare la compatibilità</p>
        <div class="ew-cart-cfg-tabs">
          <button class="ew-cart-tab ${mode==='wheels'?'active':''}" data-mode="wheels">Cerca per Auto</button>
          <button class="ew-cart-tab ${mode==='hubcap'?'active':''}" data-mode="hubcap">Coprimozzo</button>
        </div>
        <div id="ew-cart-fields" class="ew-cart-fields"></div>
        <button class="ew-cart-cfg-btn" id="ew-cart-verify" disabled>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          Verifica compatibilità
        </button>
        <div id="ew-cart-result" style="margin-top:10px;font-size:13px;font-weight:600;"></div>
      </div>
    `;

    // Stili
    const wrap = container.querySelector('.ew-cart-cfg-wrap');
    wrap.style.cssText = 'background:#f9f9f9;border-radius:8px;padding:16px;';
    container.querySelector('.ew-cart-cfg-title').style.cssText = 'font-size:13px;color:#555;margin:0 0 12px;';
    container.querySelector('.ew-cart-cfg-tabs').style.cssText = 'display:flex;gap:6px;margin-bottom:12px;';
    container.querySelectorAll('.ew-cart-tab').forEach(t => {
      t.style.cssText = 'padding:7px 14px;font-size:12px;font-weight:600;border:none;border-radius:6px;cursor:pointer;background:#e0e0e0;color:#444;';
      if (t.classList.contains('active')) t.style.cssText += 'background:#323d42;color:#fff;';
      t.addEventListener('click', () => {
        container.querySelectorAll('.ew-cart-tab').forEach(x => { x.classList.remove('active'); x.style.background='#e0e0e0'; x.style.color='#444'; });
        t.classList.add('active'); t.style.background='#323d42'; t.style.color='#fff';
        renderFields(t.dataset.mode);
      });
    });
    container.querySelector('.ew-cart-cfg-btn').style.cssText = 
      'width:100%;background:#DD1D1D;color:#fff;border:none;border-radius:8px;padding:11px;font-size:13px;font-weight:700;cursor:pointer;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:6px;opacity:.38;';
    container.querySelector('#ew-cart-verify').addEventListener('click', () => verifyCart(cdnUrl));

    renderFields(mode, prefill);

    async function renderFields(m, pre) {
      const fields = container.querySelector('#ew-cart-fields');
      fields.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;';
      fields.innerHTML = '';
      fields.dataset.mode = m;
      fields.dataset.values = JSON.stringify({});

      if (m === 'hubcap') {
        await buildHubcapFields(fields, cdnUrl, pre);
      } else {
        await buildWheelsFields(fields, cdnUrl, pre);
      }
    }
  }

  function makeSelect(placeholder, options, disabled, onChange) {
    const sel = document.createElement('select');
    sel.style.cssText = 'flex:1;min-width:120px;border:1.5px solid #e0e0e0;border-radius:7px;padding:8px 10px;font-size:12px;background:#fff;cursor:pointer;';
    if (disabled) { sel.disabled = true; sel.style.opacity = '.45'; }
    const opt0 = document.createElement('option');
    opt0.value = ''; opt0.textContent = placeholder;
    sel.appendChild(opt0);
    options.forEach(({ value, label }) => {
      const o = document.createElement('option');
      o.value = value; o.textContent = label;
      sel.appendChild(o);
    });
    sel.addEventListener('change', () => onChange(sel.value));
    return sel;
  }

  async function buildHubcapFields(fields, cdnUrl, pre) {
    const hub = await fetch(cdnUrl + 'hubcap.json').then(r => r.json());
    const brands = Object.keys(hub).sort();
    const vals = {};

    const selBrand = makeSelect('Marca', brands.map(b=>({value:b,label:b})), false, async (v) => {
      vals.make = v; vals.model=''; vals.sub_model=''; vals.engine='';
      selModel.innerHTML = '<option value="">Coprimozzo</option>';
      selModel.disabled = !v; selModel.style.opacity = v?'1':'.45';
      selDiam.innerHTML = '<option value="">Diametro</option>'; selDiam.disabled=true; selDiam.style.opacity='.45';
      selPcd.innerHTML = '<option value="">PCD</option>'; selPcd.disabled=true; selPcd.style.opacity='.45';
      checkReady();
      if (!v) return;
      Object.keys(hub[v]).sort().forEach(m => { const o=document.createElement('option'); o.value=m; o.textContent=m; selModel.appendChild(o); });
      selModel.disabled=false; selModel.style.opacity='1';
    });

    const selModel = makeSelect('Coprimozzo', [], true, (v) => {
      vals.model=v; vals.sub_model=''; vals.engine='';
      selDiam.innerHTML='<option value="">Diametro</option>'; selDiam.disabled=!v; selDiam.style.opacity=v?'1':'.45';
      selPcd.innerHTML='<option value="">PCD</option>'; selPcd.disabled=true; selPcd.style.opacity='.45';
      checkReady();
      if (!v) return;
      Object.keys(hub[vals.make][v]).sort((a,b)=>parseFloat(a)-parseFloat(b))
        .forEach(d => { const o=document.createElement('option'); o.value=d; o.textContent=d+'"'; selDiam.appendChild(o); });
    });

    const selDiam = makeSelect('Diametro', [], true, (v) => {
      vals.sub_model=v; vals.engine='';
      selPcd.innerHTML='<option value="">PCD</option>'; selPcd.disabled=!v; selPcd.style.opacity=v?'1':'.45';
      checkReady();
      if (!v) return;
      Object.keys(hub[vals.make][vals.model][v]).sort()
        .forEach(p => { const o=document.createElement('option'); o.value=p; o.textContent=p; selPcd.appendChild(o); });
      selPcd.disabled=false; selPcd.style.opacity='1';
    });

    const selPcd = makeSelect('PCD', [], true, (v) => { vals.engine=v; checkReady(); });

    fields.append(selBrand, selModel, selDiam, selPcd);
    fields.dataset.getVals = 'hubcap';
    fields._vals = vals;
    fields._hub  = hub;

    function checkReady() {
      fields._vals = vals;
      const btn = fields.closest('[id]').querySelector('#ew-cart-verify') || document.getElementById('ew-cart-verify');
      const ready = !!(vals.make && vals.model);
      if (btn) { btn.disabled = !ready; btn.style.opacity = ready ? '1' : '.38'; }
    }
  }

  async function buildWheelsFields(fields, cdnUrl, pre) {
    const idx = await fetch(cdnUrl + 'index_v4.json').then(r => r.json());
    const vals = {};
    let brandData = null;

    const selBrand = makeSelect('Marca', idx.brands.map(b=>({value:b,label:b})), false, async (v) => {
      vals.make=v; vals.model=''; vals.sub_model=''; vals.engine='';
      selModel.innerHTML='<option value="">Modello</option>'; selModel.disabled=!v; selModel.style.opacity=v?'1':'.45';
      selBody.innerHTML='<option value="">Carrozzeria</option>'; selBody.disabled=true; selBody.style.opacity='.45';
      selPow.innerHTML='<option value="">Potenza (kW)</option>'; selPow.disabled=true; selPow.style.opacity='.45';
      checkReady();
      if (!v) return;
      const slug = v.replace(/\s+/g,'_').replace(/\//g,'_').toLowerCase();
      brandData = await fetch(cdnUrl+slug+'_v4.json').then(r=>r.json());
      (idx.models[v]||[]).forEach(m => { const o=document.createElement('option'); o.value=m; o.textContent=m; selModel.appendChild(o); });
      selModel.disabled=false; selModel.style.opacity='1';
    });

    const selModel = makeSelect('Modello', [], true, (v) => {
      vals.model=v; vals.sub_model=''; vals.engine='';
      selBody.innerHTML='<option value="">Carrozzeria</option>';
      selPow.innerHTML='<option value="">Potenza (kW)</option>'; selPow.disabled=true; selPow.style.opacity='.45';
      checkReady();
      if (!v||!brandData) return;
      (brandData.bodies?.[v]||[]).forEach(b => { const o=document.createElement('option'); o.value=b; o.textContent=b; selBody.appendChild(o); });
      selBody.disabled=false; selBody.style.opacity='1';
    });

    const selBody = makeSelect('Carrozzeria', [], true, (v) => {
      vals.sub_model=v;
      selPow.innerHTML='<option value="">Potenza (kW)</option>';
      checkReady();
      if (!v||!brandData) return;
      const powers = brandData.powers?.[vals.model+'|||'+v]||[];
      if (powers.length>1) {
        powers.forEach(p => { const o=document.createElement('option'); o.value=p; o.textContent=p+' kW'; selPow.appendChild(o); });
        selPow.disabled=false; selPow.style.opacity='1';
      } else {
        vals.engine = powers[0]||'all'; checkReady();
      }
    });

    const selPow = makeSelect('Potenza (kW)', [], true, (v) => { vals.engine=v; checkReady(); });

    fields.append(selBrand, selModel, selBody, selPow);
    fields._vals = vals;
    fields._brandData = null;

    function checkReady() {
      fields._vals = vals;
      const btn = fields.closest('[id]')?.querySelector('#ew-cart-verify') || document.getElementById('ew-cart-verify');
      const ready = !!(vals.make && vals.model && vals.sub_model);
      if (btn) { btn.disabled=!ready; btn.style.opacity=ready?'1':'.38'; }
    }
  }

  async function verifyCart(cdnUrl) {
    const fields = document.getElementById('ew-cart-fields');
    if (!fields) return;
    const vehicle = { ...fields._vals, mode: fields.dataset.mode };
    const result  = document.getElementById('ew-cart-result');
    if (result) result.textContent = 'Verifica in corso...';

    try {
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      const cartSkus = cart.items.map(i => String(i.sku));
      const compatibleSkus = await getCompatibleSkus(vehicle, cdnUrl);
      const matches = cartSkus.filter(s => compatibleSkus.includes(s));
      const ok = matches.length > 0;

      if (result) {
        result.textContent = ok ? '✓ Selezione confermata' : '✗ Abbinamento non verificato';
        result.style.color = ok ? '#22c55e' : '#ef4444';
      }

      if (ok) {
        // Salva in sessionStorage e cart attributes
        ewVehicle.save(vehicle);
        const label = formatLabel(vehicle);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'ew_vehicle': label }
          })
        });
        // Aggiorna la UI dopo 1s
        setTimeout(() => location.reload(), 1200);
      }
    } catch(e) {
      if (result) { result.textContent = 'Errore durante la verifica'; result.style.color='#ef4444'; }
    }
  }

  // ── ROUTER ─────────────────────────────────────────────
  function init() {
    const path = window.location.pathname;
    if (path.startsWith('/products/')) {
      initProductPage();
    } else if (path === '/cart' || path === '/cart/') {
      initCartPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();